import { Typography } from '@customink/pigment-react';

export function EmptyCardList() {
    return (
        <Typography variant="bodyShort2">
            You don’t have any saved payment methods. Add one now to save time during checkout.
        </Typography>
    );
}
